import React, { useState, useEffect } from 'react';
import { Html } from '@react-three/drei';
import { useInfoCardState } from './useInfoCardState';

// ─── Mode 2: CSS3D (interactive, no Z-buffer) ──────────────────────────────

const InfoCardCSS3D: React.FC = () => {
    const { selection, cardPos } = useInfoCardState();
    const [visible, setVisible] = useState(false);
    const [clickCount, setClickCount] = useState(0);
    const colors = ['#3b82f6', '#ef4444', '#22c55e', '#f59e0b', '#a855f7'];

    useEffect(() => {
        if (selection) {
            setVisible(false);
            const t = setTimeout(() => setVisible(true), 100);
            return () => clearTimeout(t);
        }
        setVisible(false);
    }, [selection?.index]);

    if (!selection) return null;

    const borderColor = colors[clickCount % colors.length];

    return (
        <group position={selection.position}>
            <Html
                transform
                occlude={false}
                distanceFactor={0.5}
                position={cardPos}
                style={{
                    opacity: visible ? 1 : 0,
                    pointerEvents: visible ? 'auto' : 'none',
                    transition: 'opacity 0.3s ease',
                }}
            >
                <div
                    onPointerDown={e => e.stopPropagation()}
                    onTouchStart={e => e.stopPropagation()}
                    style={{
                        background: 'rgba(10,15,30,0.95)',
                        border: `2px solid ${borderColor}`,
                        borderRadius: '8px', padding: '10px 14px', width: '180px',
                        fontFamily: 'Inter, system-ui, sans-serif', color: '#e2e8f0',
                        boxShadow: `0 0 20px ${borderColor}40`,
                        touchAction: 'manipulation',
                    }}
                >
                    <div style={{ fontSize: '9px', color: '#64748b', marginBottom: '4px' }}>CSS3D MODE — Clicks: {clickCount}</div>
                    <div style={{ fontWeight: 700, fontSize: '12px', marginBottom: '6px', wordBreak: 'break-all' }}>
                        {selection.info?.filename ?? `Particle #${selection.index}`}
                    </div>
                    {selection.info && (
                        <div style={{ color: '#94a3b8', fontSize: '10px', marginBottom: '8px' }}>
                            {selection.info.fileSize} KB — {selection.info.extension} — {selection.info.format}
                        </div>
                    )}
                    <button
                        onClick={() => setClickCount(c => c + 1)}
                        onTouchEnd={(e) => { e.preventDefault(); setClickCount(c => c + 1); }}
                        style={{
                            width: '100%', padding: '8px 0',
                            background: borderColor, border: 'none', borderRadius: '6px',
                            color: '#fff', fontSize: '12px', fontWeight: 700,
                            cursor: 'pointer', touchAction: 'manipulation',
                        }}
                    >
                        TAP ME ({clickCount})
                    </button>
                </div>
            </Html>
        </group>
    );
};

export default InfoCardCSS3D;
